export const CHAPTER = 'chapter'
export const ORIENTATION = 'orientation'
export const REVIEW = 'review'
export const EXAM = 'exam'
export const WRITING_ASSIGNMENT = 'WritingAssignmentChapterRecord'
export const CODING_ASSIGNMENT = 'CodingAssignmentChapterRecord'
